import { Box, Typography, Skeleton } from "@mui/material";

interface StatCardProps {
  label: string;
  value: number | string;
  isLoading?: boolean;
  "data-testid"?: string;
}

function StatCard({ label, value, isLoading = false, "data-testid": dataTestId }: StatCardProps) {
  return (
    <Box
      sx={{
        padding: 3,
        border: (theme) => `1px solid ${theme.palette.divider}`,
        borderRadius: 2,
        backgroundColor: "background.paper",
        textAlign: "center",
      }}
      data-testid={dataTestId}
    >
      <Typography variant="body2" color="text.secondary" sx={{ marginBottom: 1, fontWeight: 500 }}>
        {label}
      </Typography>
      {isLoading ? (
        <Skeleton variant="text" width="60%" height={48} sx={{ margin: "0 auto" }} animation="wave" />
      ) : (
        <Typography variant="h3" component="div" sx={{ fontWeight: "bold", fontVariantNumeric: "tabular-nums" }}>
          {value}
        </Typography>
      )}
    </Box>
  );
};

export default StatCard;
